export default "__VITE_ASSET__20983a91__"